import script from "./PlayerSearchPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerSearchPage.vue?vue&type=script&setup=true&lang=js"

import "./PlayerSearchPage.vue?vue&type=style&index=0&id=599689bc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-599689bc"]])

export default __exports__